import React, { useState, useEffect, useContext } from 'react';
import { FaPen, FaFileAlt } from 'react-icons/fa';
import styles from './CampaignDetails.module.css';
import { motion } from 'framer-motion';
import { BASE_URL_API } from '../../../References/URLs';
import AuthContext from '../../../store/auth-context';
import { useParams } from 'react-router';

const CampaignDetails = ({ data, setData }) => {
    const authCtx = useContext(AuthContext)
    const { campaignIdentifier } = useParams()
    const updateDataHandler = async () => {
        
    }

    return (
        <div className={styles.container}>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
                className={styles.header}
            >
                Campaign Details
            </motion.div>

            <div className={styles.inputGroup}>
                <label htmlFor="title">
                    <FaPen className={styles.icon} />
                    <span>Title</span>
                </label>
                <motion.input
                    id="title"
                    type="text"
                    value={data?.campaignName}
                    onChange={(e) => updateDataHandler('campaignName', e.target.value)}
                    placeholder="Enter campaign title"
                    className={styles.input}
                />
            </div>

            {/* <div className={styles.inputGroup}>
                <label htmlFor="description">
                    <FaFileAlt className={styles.icon} />
                    <span>Description</span>
                </label>
                <motion.textarea
                    id="description"
                    value={data?.campaignDescription}
                    onChange={(e) => updateDataHandler('campaignDescription', e.target.value)}
                    placeholder="Enter campaign description"
                    className={styles.textarea}
                />
            </div> */}
        </div>
    );
};

export default CampaignDetails;
